<app-colored-background [backgroundColor]="'#03A97F'">
  <app-header
    [title]="locale.currentTranslation.accidentDescriptionHeader"
    [useWhiteFontColor]="true"
    [showProgressIndicator]="false"
    [showClose]="false"
    data-testid="accident-finished-header"
  ></app-header>
  <div data-testid="accident-finished-container">
    <div class="base-content-container" data-testid="accident-finished-content">
      <div class=headline1 style="color: #FFFFFF" data-testid="accident-finished-headline">
        {{ locale.currentTranslation.finishAccidentReportHeadline }}
      </div>
      <div class="text-body1" style="color: #FFFFFF" data-testid="accident-finished-text">
        {{ locale.currentTranslation.finishAccidentReportText }}
      </div>
    </div>
    <app-finish-box data-testid="accident-finished-finish-box"></app-finish-box>
    <div class="main-button-spacing" data-testid="accident-finished-button-container">
      <button class="main-button" (click)="navigateNextPage()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
    </div>
  </div>

  <app-footer data-testid="accident-finished-footer"></app-footer>
</app-colored-background>
